import { TextInput } from "react-admin";

const HmTextInput = ({ ...props }) => {
  return (
    <TextInput
      {...props}
      source={props?.source || ""}
      variant="outlined"
      sx={{
        ...props?.sx,
      }}
      helperText={false}
      // InputLabelProps={{ shrink: true }}
    />
  );
};

export default HmTextInput;
